module.exports = __webpack_public_path__ + "img/google.b38a74e4.png";